import { render, staticRenderFns } from "./roomInfo.vue?vue&type=template&id=38a2b3fb&scoped=true"
import script from "./roomInfo.vue?vue&type=script&lang=js"
export * from "./roomInfo.vue?vue&type=script&lang=js"
import style0 from "./roomInfo.vue?vue&type=style&index=0&id=38a2b3fb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a2b3fb",
  null
  
)

export default component.exports